import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { Gallery } from './index';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

// PortableComponent.cshtml uses `content.Content?.GetType().Name` as the React
// component name. Register aliases so both CMS content types that dispatch to
// the Gallery React component (ModelGallery, GallerySlideGroup) resolve client-side.
// The legacy Gallery.cshtml macro still hard-codes "Gallery" so we keep that too.
global.Gallery = Gallery;
global.ModelGallery = Gallery;
global.GallerySlideGroup = Gallery;
